import {getOrFail, modify} from 'mythil/object';
import has from 'lodash/has';
import set from 'lodash/set';
import forOwn from 'lodash/forOwn';
import { MODEL_ACTIONS } from '~/actions/model_actions';
import getConfig from '~/config';
import {getFieldData} from "~/stateGetter";
import identify from "~/identify";
import reduceFieldOptions from "./reduceFieldOptions";
import { reduceTableResults } from '~/rx/model/tableResults';
import {reduceFetchItem} from '~/rx/model/fetchItem';
import {reduceSaveItem} from '~/rx/model/saveItem';
import {reduceDeleteItem} from '~/rx/model/deleteItem';
import {reduceAutocompleteValue} from '~/rx/model/fieldOptions';
import {reduceCustomAction} from "~/rx/model/customAction";
import {reduceCustomItemAction} from "~/rx/model/itemCustomAction";
import resetItem from "~/reducers/helpers/resetItem";
import clearMessages from "~/reducers/helpers/clearMessages";
import {reduceResultParams} from "~/reducers/reduceResultParams";
import { CUSTOM_ACTION_TYPES } from '../rx/model/customAction';

export default function reduceModel(model, state, action) {
    let config  = getConfig();

    function reduceFieldValue({field, val, action}) {
        val = reduceAutocompleteValue(val, field, action);

        switch(action.type) {
            case MODEL_ACTIONS.CHANGE_FIELD_VALUE:
                return {
                    ...val,
                    value: action.value,
                    changed_at: Date.now(),
                    previousValue: val.value,
                    filterType: action.filterType,
                    created_at: action.created_at !== undefined ? action.created_at : val.created_at
                };
        }

        return val;
    }

    const reduceField = (fieldName, type, action, foo, data = {}) => {
        let key = getOrFail(config, `inputTypes.${action.inputType}.${type}`);
        let field = getFieldData(state, action.modelId, action.inputType, fieldName);

        return modify(model, `${key}.${fieldName}`, (val) => {
            return foo({ state, fieldName, val, field, action, ...data })
        });
    };

    const reduceFieldValueFor = (fieldName, action, data = {}) =>
        reduceField(fieldName, 'value', action, reduceFieldValue, data);
    const reduceFieldOptionsFor = (fieldName, action, data = {}) =>
        reduceField(fieldName, 'options', action, reduceFieldOptions, data);

    model = modify(model, 'results', (results) => reduceTableResults(results, action, state, model));
    model = reduceFetchItem(model, action, state);
    model = reduceSaveItem(model, action, state);
    model = reduceDeleteItem(model, action, state);
    model = reduceCustomAction(model, action, state);
    model = reduceCustomItemAction(model, action, state);

    switch (action.type) {
        case MODEL_ACTIONS.CHANGE_GROUP_OPEN:
            return modify(model, `filterGroups.${action.filterGroupName}`, action.open);
        case MODEL_ACTIONS.CHANGE_ACTIVE_ITEM:
            return modify(model, 'item.id', action.id);
        case MODEL_ACTIONS.CHANGE_FIELD_GROUP_OPEN:
            return modify(model, `item.rows.${action.fieldGroupName}`, action.open);
        case MODEL_ACTIONS.SET_DEFAULT_ITEM:
            model = resetItem(state, model);
            break;
        case MODEL_ACTIONS.SET_NEW_ITEM:
            model = resetItem(state, model);
            model = modify(model, 'item.id', identify.NEW_ITEM);
            model = modify(model, 'itemData.value.itemId', identify.NEW_ITEM);
            model = modify(model, 'itemData.finished_at', Date.now());
            break;
        case MODEL_ACTIONS.CHANGE_CLOSE_MODEL:
            model = modify(model, 'closeModelId', action.closeModelId);
            break;
        case MODEL_ACTIONS.HIDE_MESSAGES:
            model = clearMessages(model);
            break;
        case MODEL_ACTIONS.UPDATED_SELECTED_ROWS:
            model = modify(model, 'selectedItems', action.ids);
            model = modify(model, 'selectThroughout', action.selectThroughout);
            break;
        case CUSTOM_ACTION_TYPES.SUCCESS:
            // model = modify(model, `selectedItems`, null);
            // model = modify(model, `selectThroughout`, null);
            break;
    }
    
    model = reduceResultParams(model, action, state);

    // reduce things that are related to a single or multiple fields
    if(action.inputType && action.fieldName) {
        model = reduceFieldValueFor(action.fieldName, action);
        model = reduceFieldOptionsFor(action.fieldName, action);
    }
    if(action.inputType && action.fieldNames) {
        if(action.fieldNames instanceof Array) {
            for(let fieldName of action.fieldNames) {
                model = reduceFieldValueFor(fieldName, action);
                model = reduceFieldOptionsFor(fieldName, action);
            }
        } else {
            forOwn(action.fieldNames, (data, fieldName) => {
                model = reduceFieldValueFor(fieldName, { value: data, ...action });
                model = reduceFieldOptionsFor(fieldName, action, data);
            });
        }
    }

    return model;
}